module.exports = __webpack_public_path__ + "img/CS26Q-中_14.b1acfe99.jpg";